import styled from "styled-components";

const Form = styled.form`
    position: relative;
    display: flex;
    flex-flow: column nowrap;
    height: 100%;
`;

const AccordionBody = styled.div`
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    height: 224px;
    padding-left: 85px;
    padding-top: 20px;
    padding-bottom: 20px;
`;

const StepLabel = styled.div`
    margin-bottom: 12px;

    // TODO: Make all colours available to text and heading components in components library, and remove the below style afterwards
    span {
        color: #bfccff;
    }
`;

const QuestionWrapper = styled.div`
    max-width: 75%;
    margin-bottom: 14px;
`;

const AnswerWrapper = styled.div`
    display: flex;
`;

const DatePickerContainer = styled.div`
    min-width: 320px;
`;

const OptionsWrapper = styled.div`
    display: flex;
    margin-top: auto;

    button {
        margin-right: 12px;
    }
`;

export {
    Form,
    AccordionBody,
    StepLabel,
    QuestionWrapper,
    AnswerWrapper,
    DatePickerContainer,
    OptionsWrapper
};
